import React from 'react';
import { getCloudflareImageUrl, fetchImageMappings } from '../../utils/imageUtils';

// Preload mappings when the module is imported
fetchImageMappings().catch(err => console.error('Failed to preload image mappings:', err));

/**
 * CloudflareImage component - Automatically uses Cloudflare R2 URLs for images
 * 
 * @param {Object} props - Component props
 * @param {string} props.src - The local image path or Cloudflare URL
 * @param {string} props.alt - Alt text for the image
 * @param {Object} props.style - Additional styles for the image
 * @param {string} props.className - Additional CSS classes
 * @param {Function} props.onLoad - Callback function when image is loaded
 * @param {Function} props.onError - Callback function when an error occurs
 */
export function CloudflareImage({
  src,
  alt = '',
  style = {},
  className = '',
  onLoad,
  onError,
  ...rest
}) {
  // Convert local path to Cloudflare URL
  const cloudflareUrl = getCloudflareImageUrl(src);
  
  return (
    <img
      src={cloudflareUrl}
      alt={alt}
      style={style}
      className={className}
      onLoad={onLoad}
      onError={onError}
      {...rest}
    />
  );
}

export default CloudflareImage; 